import { Col, Form, Row, Input, Button } from "antd";
import {
  SOCIAL_MEDIA,
  getRequiredValidation,
  getSocialPlatformIcon,
} from "../../utils";
import { useEffect } from "react";

const { TextArea } = Input;

export const defaultValues = {
  description: "",
  social_media_info: [
    { account_type: SOCIAL_MEDIA.YOUTUBE },
    { account_type: SOCIAL_MEDIA.FACEBOOK },
    { account_type: SOCIAL_MEDIA.INSTAGRAM },
    { account_type: SOCIAL_MEDIA.TWITTER },
  ],
};

export const FormFields = ({ form }) => (
  <>
    <Col md={24} sm={24} span={24}>
      <Form.Item
        name="description"
        className="form-item"
        rules={[{ ...getRequiredValidation("Description") }]}
        label="Description"
        required={false}
      >
        <TextArea
          rows={4}
          placeholder="Please, give us a brief description of why you would be a good fit for this Ambassador role."
        />
      </Form.Item>
    </Col>
    <Col md={24} sm={24} span={24}>
      <Form.List name="social_media_info">
        {(fields) => (
          <Row gutter={[10, 10]} align="stretch">
            {fields?.map((field, index) => (
              <Col sm={12} xs={24} key={field.key}>
                <div className="card">
                  {getSocialPlatformIcon(
                    form.getFieldValue("social_media_info")[index].account_type
                  )}
                  <Form.Item
                    shouldUpdate={(prevValues, curValues) =>
                      prevValues?.social_media_info?.[index]?.followers !==
                      curValues?.social_media_info?.[index]?.followers
                    }
                  >
                    {() => (
                      <Form.Item
                        name={[index, "link"]}
                        rules={[
                          {
                            type: "url",
                            message: "Invalid url",
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (
                                !value &&
                                getFieldValue("social_media_info")[index]
                                  .followers
                              ) {
                                return Promise.reject(
                                  new Error("Link is required")
                                );
                              }
                              return Promise.resolve();
                            },
                          }),
                        ]}
                      >
                        <Input placeholder="Link to your profile" />
                      </Form.Item>
                    )}
                  </Form.Item>
                  <Form.Item
                    shouldUpdate={(prevValues, curValues) =>
                      prevValues?.social_media_info?.[index]?.link !==
                      curValues?.social_media_info?.[index]?.link
                    }
                  >
                    {() => (
                      <Form.Item
                        name={[index, "followers"]}
                        rules={[
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (
                                !value &&
                                getFieldValue("social_media_info")[index].link
                              ) {
                                return Promise.reject(
                                  new Error("Follower count is required")
                                );
                              }
                              return Promise.resolve();
                            },
                          }),
                        ]}
                      >
                        <Input
                          type="number"
                          min={0}
                          placeholder="Follower's count"
                        />
                      </Form.Item>
                    )}
                  </Form.Item>
                </div>
              </Col>
            ))}
          </Row>
        )}
      </Form.List>
    </Col>
  </>
);

const SocialMediaInformationForm = ({
  onSubmit,
  initialValues = defaultValues,
  isLoading,
  fromPopup = false,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(initialValues);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form]);

  return (
    <Form
      form={form}
      className="form-container social-information-form"
      onFinish={onSubmit}
      layout="vertical"
      initialValues={initialValues}
    >
      <Row gutter={fromPopup ? 0 : [20]} style={{ margin: "16px" }}>
        <FormFields form={form} />
        <Col md={24} sm={24} span={24}>
          <Form.Item className="form-item">
            <Button
              type="primary"
              htmlType="submit"
              style={{ marginTop: "10px" }}
              loading={isLoading}
            >
              Continue
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default SocialMediaInformationForm;
